import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router/immutable';

import { clearMfaChallenge, verifyMfa } from 'actions/session';

import { getMfaEmail, getMfaSession } from 'selectors/mfa';

import MfaChallenge from 'components/mfa/MfaChallenge';

import { LOGIN } from 'data/routes';

const mapStateToProps = state => ({
    email: getMfaEmail(state),
    session: getMfaSession(state),
});

const mapDispatchToProps = { verifyMfa, clearMfaChallenge, replace };

const MfaChallengeContainer = props => {
    const handleClickVerify = useCallback(values => (
        props.verifyMfa({ email: props.email, session: props.session, code: values.code })
    ), [props.email, props.session, props.verifyMfa]);

    const handleClickCancel = useCallback(() => {
        props.clearMfaChallenge();
        props.replace(LOGIN);
    }, [props.clearMfaChallenge, props.replace]);

    return (
        <MfaChallenge
            onClickCancel={handleClickCancel}
            onClickVerify={handleClickVerify}
        />
    );
};

MfaChallengeContainer.propTypes = {
    email: PropTypes.string,
    session: PropTypes.string,
    replace: PropTypes.func.isRequired,
    verifyMfa: PropTypes.func.isRequired,
    clearMfaChallenge: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(MfaChallengeContainer));
